import type { CompositeFilterDescriptor } from '@progress/kendo-data-query';

/** CompositeFilterDescriptor Logics. */
export const COMPOSITE_FILTER_DESCRIPTOR_LOGICS: CompositeFilterDescriptor['logic'][] = ['and', 'or'];

/** Condition Operator Mapping. */
export const CONDITION_OPERATOR_MAPPING = (() => {
  const notOp = ':';
  const equalsOp = 'eq';
  const greaterThanOp = 'gt';
  const lessThanOp = 'lt';
  const containsOp = 'contains';
  const inOp = 'in';
  const startWithOp = 'sw';
  const endWithOp = 'ew';
  const betweenOp = 'between';
  const emptyOp = 'empty';
  const nullOp = 'null';
  const shouldOp = '?';
  const matchOp = 'is_match';

  return {
    equals: [equalsOp, 'equals', '=', '==', '==='],
    notEquals: [`${notOp}${equalsOp}`, 'not_equals', '<>', '!=', '!=='],
    shouldEquals: [`${equalsOp}${shouldOp}`, 'should_equals', '=?', '==?', '===?'],
    shouldNotEquals: [`${notOp}${equalsOp}${shouldOp}`, 'should_not_equals', '<>?', '!=?', '!==?'],

    contains: [containsOp, '@='],
    notContains: [`${notOp}${containsOp}`, 'not_contains', '!@='],
    shouldContains: [`${containsOp}${shouldOp}`, `${shouldOp}${containsOp}`, 'should_contains', '@=?'],
    shouldNotContains: [`${notOp}${containsOp}${shouldOp}`, 'should_not_contains', '!@=?'],

    greaterThan: [greaterThanOp, 'greater_than', '>'],
    shouldGreaterThan: [`${greaterThanOp}${shouldOp}`, 'should_greater_than', '>?'],

    greaterThanOrEquals: [`${equalsOp}${greaterThanOp}`, `${greaterThanOp}${equalsOp}`, 'gte', 'greater_than_or_equals', '>='],
    shouldGreaterThanOrEquals: [
      `${equalsOp}${greaterThanOp}${shouldOp}`,
      `${greaterThanOp}${equalsOp}${shouldOp}`,
      'gte?',
      'should_greater_than_or_equals',
      '>=?',
    ],

    lessThan: [lessThanOp, 'less_than', '<'],
    shouldLessThan: [`${lessThanOp}${shouldOp}`, 'should_less_than', '<?'],

    lessThanOrEquals: [`${equalsOp}${lessThanOp}`, `${lessThanOp}${equalsOp}`, 'lte', 'less_than_or_equals', '<='],
    shouldLessThanOrEquals: [`${equalsOp}${lessThanOp}${shouldOp}`, `${lessThanOp}${equalsOp}${shouldOp}`, 'lte?', 'should_less_than_or_equals', '<=?'],

    startsWith: [startWithOp, 'starts_with', '_='],
    notStartsWith: [`${notOp}${startWithOp}`, 'not_starts_with', '!_='],
    shouldStartsWith: [`${startWithOp}${shouldOp}`, 'should_starts_with'],
    shouldNotStartsWith: [`${notOp}${startWithOp}${shouldOp}`, 'should_not_starts_with'],

    endsWith: [endWithOp, 'ends_with', '_-='],
    notEndsWith: [`${notOp}${endWithOp}`, 'not_ends_with', '!_-='],
    shouldEndsWith: [`${endWithOp}${shouldOp}`, 'should_ends_with', '_=?'],
    shouldNotEndsWith: [`${notOp}${endWithOp}${shouldOp}`, 'should_not_ends_with', '!_=?'],

    in: [inOp],
    notIn: [`${notOp}${inOp}`, 'not_in'],
    shouldIn: [`${inOp}${shouldOp}`, 'should_in'],
    shouldNotIn: [`${notOp}${inOp}${shouldOp}`, 'should_not_in'],

    between: [betweenOp],
    notBetween: [`${notOp}${betweenOp}`, 'not_between'],
    shouldBetween: [`${betweenOp}${shouldOp}`, 'should_between'],
    shouldNotBetween: [`${notOp}${betweenOp}${shouldOp}`, 'should_not_between'],

    empty: [emptyOp],
    notEmpty: [`${notOp}${emptyOp}`, 'not_empty'],
    shouldEmpty: [`${emptyOp}${shouldOp}`, 'should_empty'],
    shouldNotEmpty: [`${notOp}${emptyOp}${shouldOp}`, 'should_not_empty'],

    null: [nullOp],
    notNull: [`${notOp}${nullOp}`, 'not_null'],
    shouldNull: [`${nullOp}${shouldOp}`, 'should_null'],
    shouldNotNull: [`${notOp}${nullOp}${shouldOp}`, 'should_not_null'],

    match: [matchOp],
    notMatch: [`${notOp}${matchOp}`, 'is_not_match'],
  } as const;
})();
